import { Grid, Stack, Typography } from '@mui/material';
import { useAtomValue, useSetAtom } from 'jotai';
import React from 'react';
import { userAtom } from '../atoms/userAtom';
import { User } from '../atoms/user';

const Top = () => {
    const user = useAtomValue(userAtom);
     const setUser = useSetAtom(userAtom);
    return <>
    <div style={{height:100, background:'#3184d6', borderRadius:'0 0 5px 5px', marginBottom:10}}>
        <Grid container spacing={2}>
            <Grid item xs={4}>
            <img src={"images/ncp-white.png"} style={{height: 80}}/>
            </Grid>
            <Grid item xs={4}>
        <Typography style={{lineHeight:'80px', color:'#fff', padding:'0 10px', textAlign:'center'}} variant='h3'>
            Target#</Typography>
    </Grid>
           <Grid item xs={4} style={{textAlign:'right'}}>

            <div>
                {user && user.loggedIn && 
                    <Typography variant="body2" style={{color:'#fff', lineHeight:'100px', marginRight:20}}>Logged in as: <b>{user.id}</b> (<a href="#" style={{color:'#fff'}} onClick={() => {setUser({id:'', loggedIn: false, role:''} as User)}}>LOGOUT</a>)</Typography>
                }
            </div>
           </Grid>
            </Grid>
    </div>
    </>;
}
export default Top;